import './app';

import { initAutocomplete } from './autocomplete';
import 'jquery-steps/build/jquery.steps.js';
import 'jquery-validation';

$(document).ready(function() {
    refreshFormContents();
    initAutocomplete();

    $('input[name=type]').change(function() {
        if ($(this).prop('checked')) {
            refreshFormContents();
        }
    });

    selectSubscription();
    $('.subscription input:checked').parents('.subscription').addClass('selected');

    $(".actions ul li a, ul.tablist li a").on("click", function() {
        var type = $('input[name="type"]:checked').val();
        var email = $('input[name="email"]').val();
        var topology = $('input[name="topology"]').val();
        var address = $('input[name="address"]').val();
        var address_number = $('input[name="address_number"]').val();
        var city = $('input[name="city"]').val();
        var zip = $('input[name="zip"]').val();
        var target_zone_label = $('input[name="target_zone"]').val();
        var abbonamento = $('.subscription input:checked').parents('.subscription').find('h3').text();

        if (type == 'private') {
            var firstname = $('input[name="firstname"]').val();
            var surname = $('input[name="surname"]').val();
            var taxcode = $('input[name="taxcode"]').val();
            var pec = $('input[name="pec"]').val();

            var recap_register =
                '<div class="recap_item"><span class="recap_label">Abbonamento</span><span class="recap_value">' + abbonamento + '</span></div>' +
                '<div class="recap_item"><span class="recap_label">Nome</span><span class="recap_value">' + firstname + '</span></div>' +
                '<div class="recap_item"><span class="recap_label">Cognome</span><span class="recap_value">' + surname + '</span></div>' +
                '<div class="recap_item"><span class="recap_label">Email</span><span class="recap_value">' + email + '</span></div>' +
                '<div class="recap_item"><span class="recap_label">Codice Fiscale</span><span class="recap_value">' + taxcode + '</span></div>' +
                '<div class="recap_item"><span class="recap_label">Indirizzo</span><span class="recap_value">' + topology + ' ' + address + ' ' + address_number + '</span></div>' +
                '<div class="recap_item"><span class="recap_label">CAP</span><span class="recap_value">' + zip + '</span></div>' +
                '<div class="recap_item"><span class="recap_label">Città</span><span class="recap_value">' + city + '</span></div>' +
                '<div class="recap_item"><span class="recap_label">PEC</span><span class="recap_value">' + pec + '</span></div>' +
                '<div class="recap_item"><span class="recap_label">Prefisso</span><span class="recap_value">' + target_zone_label + '</span></div>';
        }
        else {
            var name = $('input[name="name"]').val();
            var vatcode = $('input[name="vatcode"]').val();
            var sdi_code = $('input[name="sdi_code"]').val();

            var recap_register =
                '<div class="recap_item"><span class="recap_label">Ragione Sociale</span><span class="recap_value">' + name + '</span></div>' +
                '<div class="recap_item"><span class="recap_label">Email</span><span class="recap_value">' + email + '</span></div>' +
                '<div class="recap_item"><span class="recap_label">Partita IVA</span><span class="recap_value">' + vatcode + '</span></div>' +
                '<div class="recap_item"><span class="recap_label">Indirizzo</span><span class="recap_value">' + address + '</span></div>' +
                '<div class="recap_item"><span class="recap_label">CAP</span><span class="recap_value">' + zip + '</span></div>' +
                '<div class="recap_item"><span class="recap_label">Città</span><span class="recap_value">' + city + '</span></div>' +
                '<div class="recap_item"><span class="recap_label">Codice SDI</span><span class="recap_value">' + sdi_code + '</span></div>' +
                '<div class="recap_item"><span class="recap_label">Prefisso</span><span class="recap_value">' + target_zone_label + '</span></div>';
        }

        $('#recap_register').html(recap_register);
    });
});

var form = $("#registerwizard");

$.validator.addMethod(
    "regex",
    function(value, element, regexp) {
        var check = false;
        return this.optional(element) || regexp.test(value);
    },
    "Please check your input."
);

$.validator.addMethod(
    "vatcode",
    function(value, element) {
        if (value == '') {
            return false;
        }
        if (value.length != 11) {
            return false;
        }

        valid = "0123456789";
        for (i = 0; i < 11; i++) {
            if (valid.indexOf(value.charAt(i) ) == -1) {
                return false;
            }
        }

        s = 0;
        for (i = 0; i <= 9; i += 2) {
            s += value.charCodeAt(i) - '0'.charCodeAt(0);
        }

        for (i = 1; i <= 9; i += 2) {
            c = 2 * (value.charCodeAt(i) - '0'.charCodeAt(0));
            if (c > 9) {
                c = c - 9;
            }
            s += c;
        }

        if ((10 - s % 10 ) % 10 != value.charCodeAt(10) - '0' . charCodeAt(0)) {
            return false;
        }

        return true;
    },
    "Partita IVA non valida."
);

form.validate({
    errorPlacement: function errorPlacement(error, element) {
        error.appendTo(element.closest('.row').find('.errorblock'));
    },
    rules: {
        email: {
            required: true,
            email: true
        },
        name: {
            required: true,
            minlength: 3,
        },
        firstname: {
            required: true,
        },
        surname: {
            required: true,
        },
        vatcode: {
            required: true,
            regex: /^([A-Za-z]{2}){0,1}[0-9]{11}/,
        },
        taxcode: {
            required: true,
            regex: /^[A-Za-z]{6}[0-9]{2}[A-Za-z][0-9]{2}[A-Za-z][0-9]{3}[A-Za-z]$/,
        },
        address: {
            required: true,
            minlength: 2,
        },
        address_number: {
            required: true,
        },
        sdi_code: {
            required: true,
            minlength: 7,
            maxlength: 7
        },
        zip: {
            required: true,
            number: true,
            minlength: 5,
            maxlength: 5
        },
        password: {
            required: true,
            regex: /^(((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{8,})/
        },
        password_confirmation: {
            required: true,
            equalTo: "input[name=password]"
        },
        target_zone: {
            required: true,
        },
    },
    messages: {
        name: {
            required: "Il campo è obbligatorio.",
            minlength: "Il campo deve essere composto almeno di 3 caratteri."
        },
        firstname: {
            required: "Il campo è obbligatorio.",
        },
        surname: {
            required: "Il campo è obbligatorio.",
        },
        type: {
            required: "Scegli la tipologia di account che intendi attivare. E' obbligatorio."
        },
        email: {
            required: "Il campo è obbligatorio.",
            email: "Inserisci un indirizzo email valido."
        },
        taxcode: {
            required: "Il campo è obbligatorio.",
            regex: "Inserisci un codice fiscale valido."
        },
        vatcode: {
            required: "Il campo è obbligatorio.",
            regex: "Inserisci una partita IVA valida."
        },
        address: {
            required: "Il campo è obbligatorio.",
            minlength: "Il campo deve essere composto almeno di 5 caratteri."
        },
        sdi_code: {
            required: "Il campo è obbligatorio.",
            minlength: "Il codice deve essere di 7 caratteri alfanumerici.",
            maxlength: "Il codice deve essere di 7 caratteri alfanumerici.",
        },
        password: {
            required: "Il campo è obbligatorio.",
            regex: "La password deve essere lunga almeno 8 caratteri contenere un carattere maiuscolo, uno minusco ed un numero."
        },
        password_confirmation: {
            required: "Il campo è obbligatorio.",
            equalTo: "La password che hai confermato non corrisponde a quella inserita precedentemente."
        },
        city: {
            required: "Il campo è obbligatorio."
        },
        zip: {
            required: "Il campo è obbligatorio.",
            number: "Il CAP deve essere composto solo da numeri"
        },
        target_zone: {
            required: "Il campo è obbligatorio.",
        },
    }
});

form.children("div").steps({
    headerTag: "h3",
    bodyTag: "section",
    stepsContainerTag: 'div',
    preloadContent: true,
    transitionEffect: "fade",
    transitionEffectSpeed: 200,
    titleTemplate: '<span class="btn btn-info btn-flat btn-actions"><span class="number"></span> <span class="steptitle">#title#</span></span>',
    cssClass: 'mario',

    labels: {
        cancel: "Annulla",
        current: "",
        pagination: "Paginazione",
        finish: "Finito",
        next: "Prosegui",
        previous: "Torna indietro",
        loading: "Sto caricando..."
    },

    onStepChanging: function(event, currentIndex, newIndex) {
        form.validate().settings.ignore = ":disabled,:hidden";
        return form.valid();
    },
    onFinishing: function(event, currentIndex) {
        form.validate().settings.ignore = ":disabled";
        return form.valid();
    },
    onFinished: function(event, currentIndex) {
        $("#registerwizard").submit();
    }
});

function refreshFormContents() {
    var types = new Array();
    $('input[name=type]').each(function() {
        types.push($(this).val());
    });

    var type = $('input[name=type]:checked').val();

    for (var i = 0; i < types.length; i++) {
        if (types[i] != type) {
            $('div[data-display-for*=' + types[i] + ']').hide().find('input').prop('disabled', true).prop('required', false);
        }
    }

    $('div[data-display-for*=' + type + ']').show().find('input').prop('disabled', false).filter(':not(.not-required)').prop('required', true);
}

function selectSubscription() {
    $('body').on('click', '.wizardpage  .subscription', () => {
        if ($(this).hasClass('portability')){
            $('input.portability_number').prop("required", true);
        }
        else {
            $('input.portability_number').prop("required", false);
            $('.form-control.portability_number').removeClass('error');
            $('#portability_number-error').text('');
        }
    });
}
